






































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component
export default class ColorPicker extends Vue {
  @Prop({ default: "" }) value?: string;

  open = false;
  internalColor = "";

  acceptColor() {
    this.$emit("input", this.internalColor);
    this.open = false;
  }

  clearColor() {
    this.$emit("input", null);
    this.internalColor = "";
    this.open = false;
  }

  @Watch("open")
  openWatch(fresh: string) {
    if (fresh && this.value) {
      this.internalColor = this.value;
    }
  }

  get hasPreview() {
    return !!this.$scopedSlots.preview;
  }
}
